import BaseApi from '../baseApi';

export default class UserApi extends BaseApi {
  constructor(obj){
    obj = obj || {};
    super(obj);
  }

  findAll(filters) {
    return new Promise((resolve, reject) => {
      return this.api
        .get('/users', { params: filters })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findId(user) {
    user = user || {};

    return new Promise((resolve, reject) => {
      return this.api
        .get(`/users/${user.id}`, user)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findById(id) {
    return this.api.get(`/users/${id}`);
  }

  add(user) {
    user = user || {};

    return new Promise((resolve, reject) => {
      return this.api
        .post('/users', user)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  update(user) {
    user = user || {};

    return new Promise((resolve, reject) => {
      return this.api
        .put(`/users/${user.id}`, user)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  inactive(user) {
    user = user || {};

    return new Promise((resolve, reject) => {
      return this.api
        .patch(`/users/${user.id}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }
}
